import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";
import { PageHeader, Loading, Card, RegStatusBadge } from "../components/common";

const DISCLAIMER = "Mappings shown are advisory guidance for governance assessment purposes. QAI is a draft policy, not enacted legislation. AI-ETH and AI-DEV are voluntary guidance. NCSA-AI is voluntary guidance that does not remove existing legal obligations. PDPL and applicable sector requirements may be binding. This application is not legal advice.";

export default function Regulatory() {
  const { t, lang } = useI18n();
  const [regs, setRegs] = useState(null);
  useEffect(() => { api.get("/regulations").then((r) => setRegs(r.data)); }, []);
  if (!regs) return <Loading />;

  const dist = {};
  regs.forEach((r) => { dist[r.status] = (dist[r.status] || 0) + 1; });
  const distData = Object.entries(dist).map(([name, value]) => ({ name, value }));
  const COL = { LAW: "#7C3AED", MANDATORY: "#DC2626", FRAMEWORK: "#2563EB", GUIDELINE: "#D97706", VOLUNTARY: "#059669", DRAFT: "#6B7280" };

  return (
    <div>
      <PageHeader title={t("nav.regulatory")} subtitle="Database-driven Qatar regulatory reference engine" summary="Qatar Regulatory Engine. Eighteen reference codes with clear status distinctions from law to draft. Mappings are advisory, not legal advice." />

      <div className="mb-4 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800" data-testid="reg-disclaimer">{DISCLAIMER}</div>

      <div className="grid gap-6 lg:grid-cols-3">
        <Card title="Status Distribution" className="lg:col-span-1">
          <ResponsiveContainer width="100%" height={260}>
            <PieChart><Pie data={distData} dataKey="value" nameKey="name" outerRadius={85}>{distData.map((e, i) => <Cell key={i} fill={COL[e.name] || "#94a3b8"} />)}</Pie><Tooltip /><Legend /></PieChart>
          </ResponsiveContainer>
        </Card>

        <div className="lg:col-span-2 space-y-3">
          {regs.map((r) => (
            <div key={r.code} data-testid={`reg-${r.code}`} className="rounded-2xl border border-slate-200 bg-white p-4 card-shadow">
              <div className="flex flex-wrap items-start justify-between gap-2">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="rounded-md bg-slate-900 px-2 py-0.5 font-mono text-xs font-bold text-white">{r.code}</span>
                    <RegStatusBadge status={r.status} />
                  </div>
                  <p className="mt-1.5 text-sm font-semibold text-slate-800">{lang === "ar" ? r.name_ar : r.name}</p>
                  <p className="text-xs text-slate-500">Authority: {r.authority} · Scope: {r.scope}</p>
                </div>
                <div className="text-end text-xs">
                  <p className="text-slate-400">Applicable use cases</p>
                  <p className="text-lg font-bold text-[var(--qatar)]">{r.applicable_usecases}</p>
                </div>
              </div>
              <p className="mt-2 rounded-lg bg-slate-50 px-3 py-1.5 text-xs text-slate-600">{r.note}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
